module.exports = __webpack_public_path__ + "static/img/a080.b5d6c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a080.jpg
// module id = mRXx
// module chunks = 0